import { createSlice } from "@reduxjs/toolkit";

const getInitialDarkMode = () => {
    if (typeof window === 'undefined') return true;

    const storedTheme = window.localStorage.getItem('theme');
    if (storedTheme) return storedTheme === 'dark';

    return true;
};

const initialState = {
    isDarkMode: getInitialDarkMode()
}

export const darkSlice = createSlice({
    name: 'darkMode',
    initialState,
    reducers: {
        setIsDarkMode : (state) => {
            state.isDarkMode = !state.isDarkMode;
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
            }
        },
        setDarkMode : (state, action) => {
            state.isDarkMode = Boolean(action.payload);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
            }
        }
    }
})

export const { setIsDarkMode, setDarkMode  } = darkSlice.actions

export default darkSlice.reducer
